export const handleMenuMouseLeave = (elementId,resetFn) => {
  if (typeof document == 'undefined')
    return;
  const mouseTarget = document.getElementById(elementId);
  if (mouseTarget && document.readyState === "complete") {
    let timeout = null;
    mouseTarget.addEventListener("mouseleave", (e) => {
      timeout = setTimeout(resetFn, 500);
    });
    mouseTarget.addEventListener("mouseenter", (e) => {
      if (timeout) {
        clearTimeout(timeout);
      }
    });
  }
}
